import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: window.matchMedia('(prefers-color-scheme: dark)').matches,
    themes: {
      light: {
        primary: '#3391FF',
        darkBlue: '#3391FF',
        lightBlue: '#EEF6FF',
        darkOrange: '#DF8E00',
        lightOrange: '#FCF3E6',
        darkGreen: '#41BF21',
        lightGreen: '#E5FBE1',
        darkRed: '#F50002',
        lightRed: '#FEEBEB',
        darkYellow: '#F4DD00',
        lightYellow: '#FDF7CE',
        lightGrey: '#E5E8Ea',
        darkGrey: '#6A7781',
        black: '#021E33',
        white: '#F9FBfD',
        background: '#F9FBfD',
        sidebar: '#021E33',
        tab: '#Df8E00',
      },
      dark: {
        primary: '#3391FF',
        darkBlue: '#3391FF',
        lightBlue: '#1a3a52',
        darkOrange: '#E49A00',
        lightOrange: '#2d2416',
        darkGreen: '#41BF21',
        lightGreen: '#1a2e17',
        darkRed: '#F50002',
        lightRed: '#2d1515',
        darkYellow: '#F4DD00',
        lightYellow: '#2d2a15',
        lightGrey: '#3a3a3a',
        darkGrey: '#a2a2a2',
        black: '#E5E8EA',
        white: '#212121',
        background: '#1b1b1b',
        sidebar: '#1b1b1b',
        topbar: '#1b1b1b',
        tab: '#E49A00',
      },
    },
  },
})
